function buildQuestion() {
  let questions = [];
  let signs = new Map<string, number>();
  let total = 0;

  while (total < 20) {
    let a = random();
    let b = random();
    let c = "+";
    if (a + b > 10) {
      c = "-";
      if (a < b) {
        let aa = a;
        a = b;
        b = aa;
      }
    }
    let sign = a + c + b;
    if (signs.has(sign)) {
      continue;
    }
    signs.set(sign, 1);
    questions.push([a, c, b]);
    total++;
  }
  return questions;
}

function random() {
  return parseInt((Math.random() * 10).toString());
}

export {buildQuestion, random};